var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import * as ServiceAffaire from '../../services/affaire';
import * as ServiceUtils from '../../services/utils';
import { Loader } from '../../utils/Loader';
import { FormikGenerator, TYPES } from '../../utils/FormikGenerator';
import { AffaireIcon } from '../../utils/Icons';
import { Modal } from '../../utils/Modal';
import { AffaireSchema } from '../../utils/ValidationSchema';
import { getYearAndMonthInStringDate } from '../../services/dashboard';
import { getOriginalUser } from '../../services/utilisateur';
import { toUpperCaseFirstChar } from '../../theme';
export var EditionAffaire = function (props) {
    var originalUser = getOriginalUser();
    var AffaireId = props.AffaireId, ClientId = props.ClientId, handleClose = props.handleClose;
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), affaire = _b[0], setAffaire = _b[1];
    var _c = useState([]), typesAffaire = _c[0], setTypesAffaire = _c[1];
    var _d = useState([]), probabilites = _d[0], setProbabilites = _d[1];
    var _e = useState([]), tags = _e[0], setTags = _e[1];
    var _f = useState([]), collaborateurs = _f[0], setCollaborateurs = _f[1];
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var datas, _a, Annee, Mois, newCollaborateurs;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, Promise.all([
                                ServiceAffaire.getAffaire(AffaireId, ClientId),
                                ServiceUtils.getTypes('Affaire'),
                                ServiceUtils.getTypes('Probabilite'),
                                ServiceUtils.getTypes('Tag'),
                            ])];
                    case 1:
                        datas = _b.sent();
                        _a = getYearAndMonthInStringDate(datas[0].MoisSignature), Annee = _a.Annee, Mois = _a.Mois;
                        datas[0].OnlyYearMoisSignature = Annee;
                        datas[0].OnlyMonthMoisSignature = Mois;
                        setAffaire(datas[0]);
                        setTypesAffaire(datas[1]);
                        setProbabilites(datas[2]);
                        setTags(datas[3]);
                        setLoading(false);
                        return [4 /*yield*/, ServiceUtils.getSelectOptions('collaborateurs', { ClientId: datas[0].ClientId })];
                    case 2:
                        newCollaborateurs = _b.sent();
                        setCollaborateurs(newCollaborateurs);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    var renderForm = function () {
        return (_jsx(FormikGenerator, { validationSchema: AffaireSchema, submitLabel: AffaireId ? 'Enregistrer' : 'Ajouter', validate: function (_a) {
                var values = _a.values;
                if (values.DateDebut &&
                    values.DateFin &&
                    new Date(values.DateDebut) > new Date(values.DateFin)) {
                    return 'La date de début est supérieure à la date de fin';
                }
            }, datas: affaire, onSubmit: function (affaire) { return __awaiter(void 0, void 0, void 0, function () {
                var isOk;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            affaire.MoisSignature =
                                affaire.OnlyYearMoisSignature * 100 + affaire.OnlyMonthMoisSignature;
                            return [4 /*yield*/, ServiceAffaire.postAffaire(ClientId, AffaireId, affaire)];
                        case 1:
                            isOk = (_a.sent()).isOk;
                            if (isOk) {
                                handleClose();
                            }
                            return [2 /*return*/];
                    }
                });
            }); }, additionalInitialValues: ['IdAffaire', 'ClientId'], fields: [
                [
                    {
                        xs: 4,
                        label: 'Propriétaire',
                        name: 'CollaborateurProprietaireId',
                        type: TYPES.SELECT,
                        options: collaborateurs,
                        show: function (values) {
                            return originalUser.Licence.UseVision && !values.IdAffaire;
                        },
                    },
                    {
                        xs: 8,
                        name: 'DuplicateEquipe',
                        label: "Dupliquer l'équipe du client",
                        type: TYPES.BOOLEAN,
                        show: function (values) {
                            return originalUser.Licence.UseVision && !values.IdAffaire;
                        },
                    },
                    {
                        xs: 4,
                        name: 'Libelle',
                        label: 'Libelle',
                        type: TYPES.TEXT,
                        uppercaseFirstChar: true,
                    },
                    {
                        xs: 4,
                        name: 'AffaireTypeId',
                        label: 'Type',
                        type: TYPES.SELECT,
                        options: typesAffaire,
                        isRequired: "La type d'affaire",
                    },
                    {
                        xs: 4,
                        name: 'ProbabiliteTypeId',
                        label: 'Probabilité',
                        type: TYPES.SELECT,
                        options: probabilites,
                        isRequired: 'La probabilité',
                    },
                    {
                        xs: 4,
                        name: 'DateDebut',
                        label: 'Date début',
                        type: TYPES.TEXT,
                        datePicker: true,
                    },
                    {
                        xs: 4,
                        name: 'DateFin',
                        label: 'Date fin',
                        type: TYPES.TEXT,
                        datePicker: true,
                    },
                    {
                        xs: 2,
                        name: 'OnlyMonthMoisSignature',
                        label: 'Mois signature',
                        type: TYPES.SELECT,
                        isRequired: true,
                        options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (month) {
                            return {
                                value: month + 1,
                                label: toUpperCaseFirstChar(new Date(0, month, 1).toLocaleString('fr-FR', {
                                    month: 'long',
                                })),
                            };
                        }),
                    },
                    {
                        xs: 2,
                        name: 'OnlyYearMoisSignature',
                        label: 'Année signature',
                        type: TYPES.TEXT,
                        isRequired: true,
                        onlyDigits: true,
                    },
                    {
                        name: 'Tags',
                        label: 'Tags',
                        type: TYPES.SELECT,
                        options: tags,
                        multiple: true,
                    },
                    {
                        name: 'Commentaire',
                        label: 'Commentaire',
                        type: TYPES.TEXT,
                        multiline: true,
                    },
                    {
                        name: 'Details',
                        label: 'Détails (visible sur devis)',
                        type: TYPES.TEXT,
                        multiline: true,
                    },
                ],
            ] }));
    };
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Affaire", color: "affaire", iconTitle: _jsx(AffaireIcon, {}) }, { children: loading ? _jsx(Loader, {}) : renderForm() })) }));
};
//# sourceMappingURL=EditionAffaire.js.map